import { render, staticRenderFns } from "./addtohomescreen.vue?vue&type=template&id=a9a198e4&scoped=true&"
import script from "./addtohomescreen.vue?vue&type=script&lang=js&"
export * from "./addtohomescreen.vue?vue&type=script&lang=js&"
import style0 from "./addtohomescreen.vue?vue&type=style&index=0&id=a9a198e4&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9a198e4",
  null
  
)

export default component.exports